import { NgModule } from '@angular/core';
import { ErrorDialogComponent } from './errors/error-dialog/error-dialog.component';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ErrorDialogService } from './errors/error-dialog.service';
import { LoadingBarComponent } from './loading/loading-bar/loading-bar.component';
import { LoadingBarService } from './loading/loading-bar.service';
import { MaterialModule } from '../material.module';
import { HoldToConfirmButtonComponent } from './hold-to-confirm-button/hold-to-confirm-button.component';
import { FeatureFlagDirective } from './directives/feature-flag.directive';
import { LongPressDirective } from './directives/long-press.directive';
import { ShowLegacyDirective } from './directives/show-legacy.directive';
import { ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { AngularIbanModule } from 'angular-iban';
import { ClientBankAccountsComponent } from '../components/client-bank-accounts/client-bank-accounts.component';
import { PermissionGateComponent } from './permission-gate/permission-gate.component';

const sharedComponents = [
  ErrorDialogComponent, LoadingBarComponent, HoldToConfirmButtonComponent, ClientBankAccountsComponent, PermissionGateComponent,
];
const sharedDirectives = [FeatureFlagDirective, LongPressDirective, ShowLegacyDirective];
//const sharedPipes = [MoneyPipe];

@NgModule({
    declarations: [...sharedComponents, ...sharedDirectives],
    imports: [CommonModule, RouterModule, MaterialModule, ReactiveFormsModule, FlexLayoutModule, AngularIbanModule],
    exports: [...sharedComponents, ...sharedDirectives, AngularIbanModule],
    providers: [ErrorDialogService, LoadingBarService]
})
export class SharedModule {}
